import React from "react";
import "./GlobalFormShell.css";

export default function GlobalFormShell({
  legend,
  showAlert,
  alertText,
  alertId,
  formAlertRef,
  children,
  actions,
  /** When true, fieldset does not clip overflow (e.g. typeahead dropdowns inside the shell). */
  overflowVisible = false,
  /** Extra class on the inner grid, e.g. `gfs-form-grid--3cols` */
  gridClassName = "",
}) {
  return (
    <fieldset
      className={`gfs-fieldset${overflowVisible ? " gfs-fieldset--overflow-visible" : ""}`}
    >
      <legend>{legend}</legend>

      {showAlert ? (
        <div
          ref={formAlertRef}
          id={alertId}
          className="gfs-form-alert gfs-form-alert--error"
          role="alert"
        >
          {alertText}
        </div>
      ) : null}

      <div className={`gfs-form-grid ${gridClassName}`.trim()}>{children}</div>

      {actions ? <div className="gfs-form-actions">{actions}</div> : null}
    </fieldset>
  );
}

